<template>
  <div class="embed-responsive embed-responsive-16by9">
    <iframe
      :src="`https://www.youtube.com/embed/${live.video_code}`"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      class="embed-responsive-item"
    ></iframe>
  </div>
</template>

<script>
  export default {
    props: {
      live: { type: Object, default: () => ({}) }
    }
  }
</script>